__turbopack_context__.v({
  "cookieToggle": "CookieToggle-module-scss-module__oEHnsW__cookieToggle",
  "toggle": "CookieToggle-module-scss-module__oEHnsW__toggle",
});
